import {Events, ServerMethod, DEFAULT_FILE_PARAMS} from './constant';
import {Vue} from "ui.vue";


/**
 * Код куки, в которой хранятся выбранные настройки даты доставки
 * @type {string}
 */
const DELIVERY_TIME_CHECKED = "savedDeliveryTime";

export let propertyMixin = {
	store: BX.Citrus.Vuex.store,
	data() {
		return {
			propertyList: [],
			propertyDefaultText: [],
			alternativeLocationPropertyId: 0,
			canSetDeliveryTime: false,
			lastDeliveryTime: "",
			lastDeliveryTypeTime: "",
			defaultDeliveryTime: "",
			pickupDeliveryTime: false,
		}
	},
	computed: {
		alternativeLocationProperty() {
			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				for (let itemProperty of gProperty.items) {
					if (this.alternativeLocationPropertyId === itemProperty.ID) {
						return itemProperty;
					}
				}
			}

			return false;
		},
		afterLocationProp() {
			for (let gIndex in this.propertyList) {
				let gGroup = this.propertyList[gIndex];

				for (let subgroups of gGroup.groups) {
					for (let pIndex in subgroups.items) {
						let itemProperty = subgroups.items[pIndex];
						if ('location' != itemProperty.TYPE) {
							continue;
						}

						let nextIndex = parseInt(pIndex) + 1;
						if (typeof subgroups.items[nextIndex] == 'undefined') {
							continue;
						}

						return subgroups.items[nextIndex];
					}
				}
			}

			return {
				ID: 0
			};
		},
		locationProperty() {
			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				for (let itemProperty of gProperty.items) {
					if ("location" == itemProperty.TYPE) {
						return itemProperty;
					}
				}
			}

			return {
				ID: 0
			};
		}
	},
	methods: {
		__preparePropertyList($groups, $properties) {
			let result = {};
			for (let group of $groups) {
				result[group.ID] = {
					name: group.NAME,
					code: group.CODE,
					items: [],
					groups: [],
				};
			}

			for (let pIndex in $properties) {
				let property = $properties[pIndex];
				let type = property.TYPE.toLowerCase();
				if ('Y' == property.IS_EMAIL) {
					type = "email";
				} else if ('Y' == property.IS_PHONE) {
					type = "phone";
				}

				let value = (Array.isArray(property.VALUE) ? property.VALUE[0] : property.VALUE),
					values = [];

				if (property.hasOwnProperty('OPTIONS_SORT')) {
					for (let optionCode of property.OPTIONS_SORT) {
						values.push({
							ID: optionCode,
							label: property.OPTIONS[optionCode]
						});
					}
				}

				if (type == "location") {
					this.alternativeLocationPropertyId = property.hasOwnProperty('INPUT_FIELD_LOCATION') ? property.INPUT_FIELD_LOCATION : 0;
				}

				let prop = {
					ID: property.ID,
					CODE: property.CODE,
					TITLE: property.NAME,
					REQUIRED: property.REQUIRED,
					PLACEHOLDER: "",
					DESCRIPTION: property.DESCRIPTION,
					TYPE: type,
					ROW_CLASS: 'form__group',
					VALUE: value,
					VALUES: values,
					IS_LOCATION: property.IS_LOCATION,
					RULES: []
				};

				if (property.MAXLENGTH && property.MAXLENGTH.length > 0) {
					prop.RULES = [];
					prop.RULES.push("max:" + property.MAXLENGTH);
				}

				if (property.MINLENGTH && property.MINLENGTH.length > 0) {
					prop.RULES = [];
					prop.RULES.push("min:" + property.MINLENGTH);
				}

				prop.RULES = prop.RULES.join("|");

				result[property.PROPS_GROUP_ID].items.push(prop);

				if ('DELIVERY_TIME' == property.CODE) {
					this.initSelectTimeType(value);
				}

				if (this.alternativeLocationPropertyId == property.ID) {
					continue;
				}

				if (this.params.hasOwnProperty('PROPERTY_GROUP_SETTINGS')) {
					let subgroup = this.params.PROPERTY_GROUP_SETTINGS.findIndex((element) => {
						return element.includes(property.CODE);
					});
					if (subgroup < 0) {
						subgroup = 0
					}

					if (!result[property.PROPS_GROUP_ID].groups.hasOwnProperty(subgroup)) {
						result[property.PROPS_GROUP_ID].groups[subgroup] = {
							items: [],
							count: 0
						};
					}

					result[property.PROPS_GROUP_ID].groups[subgroup].items.push(prop);

					result[property.PROPS_GROUP_ID].groups[subgroup].count++;
					if (prop.TYPE == "location") {
						let nextIndex = parseInt(pIndex) + 1;
						if (typeof $properties[nextIndex] != 'undefined') {
							result[property.PROPS_GROUP_ID].groups[subgroup].count--;
						}
					}
				}
			}

			this.propertyList = result;
		},
		onFileSelect(field) {
			let id = parseInt(field.ID);
			if (!this.propertyDefaultText.hasOwnProperty(id)) {
				this.propertyDefaultText[id] = field.PLACEHOLDER;
			}

			if (undefined === field.VALUE) {
				field.PLACEHOLDER = this.propertyDefaultText[id];
			} else {
				field.PLACEHOLDER = this.renderFileName(field.VALUE.name);
			}
		},
		renderFileName(_name) {
			let _limit = DEFAULT_FILE_PARAMS.NAME_LENGTH_LIMIT;

			if (_name.length <= _limit)
				return _name;

			let _fileExt = _name.split('.').pop();

			let newName = _name.substr(0, _limit);

			return [newName, '~', ".", _fileExt].join("");
		},
		setLocationAddress(params) {
			let code = params.location.value;
			this.setPropertyValue(code, "location", "TYPE");

			/**
			 * Запрос на обновление, только если была выбрана улица
			 */
			if (code && (!params.hasOwnProperty('isPreset') || !params.isPreset)) {
				Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REFRESH});
			}
		},
		setStoreAddress(address) {
			this.setPropertyValue(address, "ADRESS", "CODE");
		},
		initSelectTimeType(curValue) {
			this.defaultDeliveryTime = "";

			this.lastDeliveryTime = this.pickupDeliveryTime ? this.pickupDeliveryTime : this.getDeliveryTime();
			if (!this.lastDeliveryTime) {
				this.lastDeliveryTime = this.defaultDeliveryTime;
			}

			let {DELIVERY_TIME} = this.getDeliveryTimeForSave(null, null);
			this.lastDeliveryTypeTime = DELIVERY_TIME;

			this.onSelectTimeType(curValue, false);
		},
		onSelectTimeType(curValue, refresh = true)
		{
			this.canSetDeliveryTime = (curValue === "select_time");
			if (!this.canSetDeliveryTime) {
				// проверять по товарам. По дате уже ошибка
				let checkBasketStock = this.result.IIKO_DELIVERY_TIME.hasQuantityError;
				if (checkBasketStock) {
					// показать модальное окно
					console.log('показать модальное окно', {
						warningDateTime: this.getDeliveryTime(),
						cancelDateTime: this.getDeliveryTime(),
						cancelDateTypeTime: this.lastDeliveryTypeTime,
					});
					setTimeout(() => {
						this.setVisiblePopup("PopupChangeDeliveryTime", true, {
							productList: this.result.PREPARED_ITEMS,
							warningDateTime: this.getDeliveryTime(),
							cancelDateTime: this.getDeliveryTime(),
							cancelDateTypeTime: this.lastDeliveryTypeTime,
							loading: false
						});
					}, 100);

					return;
				}
			}

			if (!this.canSetDeliveryTime) {
				this.lastDeliveryTime = this.getDeliveryTime();
				this.setDeliveryTime("");
			} else {
				//this.setDeliveryTime(this.lastDeliveryTime ? this.lastDeliveryTime : this.defaultDeliveryTime);
			}

			let obProperty = this.getProperty("PICKUP_TIME", "CODE");
			if (obProperty) {
				this.changePropertyUserData(obProperty.ID, obProperty ? obProperty.VALUE : "");
			}

			/*console.log(curValue, '-', this.canSetDeliveryTime, '-', this.lastDeliveryTime, '-', this.defaultDeliveryTime);
			console.log(obProperty ? obProperty.VALUE : "");*/
			//this.saveDeliveryTimeCookie(curValue, !this.canSetDeliveryTime ? "" : (this.lastDeliveryTime ? this.lastDeliveryTime : this.defaultDeliveryTime));
			this.saveDeliveryTimeCookie(curValue, !this.canSetDeliveryTime ? "" : this.getDeliveryTime());
			this.lastDeliveryTypeTime = curValue;
			if(refresh)
			{
				Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REFRESH});
			}
		},
		onSelectDate(id, value) {
			this.changePropertyUserData(id, value);
			this.saveDeliveryTimeCookie(null, value);
			Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REFRESH});
		},
		onWarningSelectDate(id, warningValue) {
			// проверять по товарам. По дате уже ошибка
			let checkBasketStock = this.result.IIKO_DELIVERY_TIME.hasQuantityError;
			if (checkBasketStock) {
				// показать модальное окно
				console.log('показать модальное окно', {
					warningDateTime: warningValue,
					cancelDateTime: this.getDeliveryTime(),
					cancelDateTypeTime: this.lastDeliveryTypeTime,
				});
				this.setVisiblePopup("PopupChangeDeliveryTime", true, {
					productList: this.result.PREPARED_ITEMS,//this.additionalProductList
					warningDateTime: warningValue,
					cancelDateTime: this.getDeliveryTime(),
					cancelDateTypeTime: this.lastDeliveryTypeTime,
					loading: false
				});
			}
			else {
				console.log('новая дата ', warningValue);
				this.setPropertyValue(warningValue, "PICKUP_TIME", "CODE");
				this.onSelectDate(id, warningValue);
				this.onChangeDeliveryTime();
			}
		},
		setDeliveryTimeWithChange(value) {
			this.setDeliveryTime(value);
			let obProperty = this.getProperty("PICKUP_TIME", "CODE");
			if (obProperty) {
				this.changePropertyUserData(obProperty.ID, this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE);
			}
			this.saveDeliveryTimeCookie(null, this.result.IIKO_DELIVERY_TIME.PICKUP_TIME_VALUE);
		},
		setDeliveryTime(value) {
			this.setPropertyValue(value, "PICKUP_TIME", "CODE");
		},
		changeViewStock(type, time) {
			if (type === 'now' || (type === '' && time === '')) {
				//console.log("отображать наличие");
				this.$store.dispatch('basket/toggleViewStock', true);
				return;
			}

			let chosenDateArray = time.split(' ');
			let chosenDate = chosenDateArray[0].split('.').reverse().join('-');
			let formattedChosenDate = chosenDate + 'T' + chosenDateArray[1];
			formattedChosenDate = new Date(formattedChosenDate);
			formattedChosenDate.setMinutes(formattedChosenDate.getMinutes() + this.$store.getters['basket/orderMakeMinutes']);

			let availableDate = this.result.IIKO_DELIVERY_TIME.stock.min_date.split('.').reverse().join('-');
			let formattedAvailableDate = availableDate + `T${this.result.IIKO_DELIVERY_TIME.stock.min_time}`;

			let compareDate = formattedChosenDate.getTime() < new Date(formattedAvailableDate).getTime();
			this.$store.dispatch('basket/toggleViewStock', compareDate);

			//console.log(type, '-', time, '-', formattedChosenDate, '-', formattedAvailableDate);
		},
		saveDeliveryTimeCookie(type = null, time = null) {
			let result = this.getDeliveryTimeForSave(type, time);
			//console.log("old.", this.getDeliveryTimeCookie());
			//console.log("saveDeliveryTimeCookie. try ", type, time, "set ", result);
			let encoded = JSON.stringify(result);

			this.changeViewStock(result.DELIVERY_TIME, result.PICKUP_TIME);

			BX.setCookie(DELIVERY_TIME_CHECKED, encoded, this.getCookieOptions());
		},
		// domain нужен, чтобы кука распространялась на поддомены тоже
		getCookieOptions(expires = null) {
			let options = Object.assign({}, {path: BX.message("SITE_DIR"), domain: document.domain});

			if (expires !== null) {
				options.expires = expires;
			}

			return options;
		},
		getDeliveryTimeForSave(typeVal, time) {
			let obTypeProperty = this.getProperty("DELIVERY_TIME", "CODE");

			if (typeVal == null) {
				typeVal = obTypeProperty ? obTypeProperty.VALUE : "";
			}

			return {
				'DELIVERY_TIME': typeVal,
				'PICKUP_TIME': typeVal === "select_time" ? (time != null ? time : this.getDeliveryTime()) : ""
			};
		},
		getDeliveryTimeCookie() {
			return BX.getCookie(DELIVERY_TIME_CHECKED) ? JSON.parse(BX.getCookie(DELIVERY_TIME_CHECKED)) : null;
		},
		clearDeliveryTimeCookie() {
			BX.setCookie(DELIVERY_TIME_CHECKED, "", this.getCookieOptions(-1));
		},
		getDeliveryTime() {
			let obProperty = this.getProperty("PICKUP_TIME", "CODE");
			return obProperty ? obProperty.VALUE : "";
		},
		setPropertyValue(value, property, fieldCode) {
			let obProperty = this.getProperty(property, fieldCode);
			if (obProperty && obProperty.VALUE != value) {
				obProperty.VALUE = value;
			}
		},
		setDeliveryTimePropertyValues(params) {
			for (let propertyCode in params) {
				let obProperty = this.getProperty(propertyCode, "CODE");
				this.setPropertyValue(params[propertyCode], propertyCode, "CODE");

				this.changePropertyUserData(obProperty.ID, params[propertyCode])
			}
		},
		setPropertyValues(params) {
			for (let propertyCode in params) {
				this.setPropertyValue(params[propertyCode], propertyCode, "CODE");
			}
		},
		getProperty(property, fieldCode) {
			for (let gIndex in this.propertyList) {
				let gProperty = this.propertyList[gIndex];
				for (let itemProperty of gProperty.items) {
					if (property != itemProperty[fieldCode])
						continue;

					return itemProperty;
				}
			}

			return null;
		}
	}
}

export default propertyMixin;
